import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import RenderCategoriesInputField from 'components/form/InputFields/AutoCompleteField/RenderCategoriesInputField';
import RenderProviderInputField from 'components/form/InputFields/AutoCompleteField/RenderProviderInputField';
import RenderSubCategoriesInputField from 'components/form/InputFields/AutoCompleteField/RenderSubCategoriesInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import rolesHelper from 'helpers/roles';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

class ProductsEdit extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        if (!utils.isEmpty(data)) {
            initialize({
                category_id: data.category_id,
                is_visible: data.is_visible,
                phone: data.phone,
                provider_id: data.provider_id,
                subcategory_id: data.subcategory_id,
                title: data.title,
            });
        }
    }

    render() {
        const {
            categoryId,
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.products.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.title') }
                                    name='title'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCategoriesInputField }
                                    fullWidth={ true }
                                    label={ 'resources.products.fields.category_id' }
                                    name='category_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        { categoryId &&
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderSubCategoriesInputField }
                                        categoryId={ categoryId }
                                        fullWidth={ true }
                                        label={ 'resources.products.fields.subcategory_id' }
                                        name='subcategory_id'
                                    />
                                </Item>
                            </Row>
                        }
                    </Section>

                    <Section title={ translate('resources.products.forms.provider') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderProviderInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.provider_id') }
                                    name='provider_id'
                                    searchParams={ {
                                        role_id: [
                                            rolesHelper.getProviderRoleId(),
                                        ],
                                        size: '12',
                                        sort_by: 'name',
                                        sort_direction: 'asc',
                                    } }
                                    reference='accounts'
                                    optionValue='id'
                                    searchBy='name'
                                    source='provider_id'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.phone') }
                                    name='phone'
                                    source='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.products.forms.preferences') } >
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.is_visible') }
                                    name='is_visible'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProductsEdit.propTypes = {
    categoryId: PropTypes.number,
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    const selector = formValueSelector(form);
    const hasCategoryId = selector(state, 'category_id');

    return {
        categoryId: hasCategoryId,
    };
};

const enhance = compose(
    translate,
    reduxForm(),
    connect(
        mapStateToProps,
        null,
    ),
);

export default enhance(ProductsEdit);



// WEBPACK FOOTER //
// ./src/pages/products/edit/ProductsEditForm.js